/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, Backbone, YT */

_.namespace(`Backbone.widgets`, function() {
  'use strict';
  var id_generator = 0,
    youtube_api_onload = function() {};

  window.onYouTubeIframeAPIReady = function() {
    youtube_api_onload();
  };

  var YouTubeView = Backbone.Widget.extend({
    api_url: `https://www.youtube.com/iframe_api`,
    className: `backbone_youtube_view`,

    templates: {
      base: `<div class='cover'><div class='play'></div><img></div><div id='<%= d.yt_id %>'></div>`,
    },

    events: {
      'click .cover': `play`,
    },

    initialize() {
      this.yt_id = _.sprintf(`youtube_embed_%d`, id_generator++);
      this.player_ready = false;

      this.$el.addClass(this.className);
      this.render();

      this.load(this.options.video_id, this.options.cover_img_url, this.options.autoplay);
    },

    render() {
      this.render_base_template({yt_id: this.yt_id});
      this.cover = this.$(`.cover`);
      this.cover_img = this.$(`.cover img`);

      // needed for the cover image
      this.$el.css({'position': `relative`});
    },

    listen_for_events() {
      this.on(`video:play`, function() { this.api.playVideo(); });
      this.on(`video:pause`, function() { this.api.pauseVideo(); });
      this.on(`video:stop`, function() { this.api.stopVideo(); });
    },

    load_api(autoplay) {
      if (this.loading_api || !$(`#` + this.yt_id).length) { return; }
      this.loading_api = true;
      $($(`script`)[0]).before($(`<script>`).attr(`src`, this.api_url));
      youtube_api_onload = _.bind(this.api_loaded, this, autoplay);
    },

    api_loaded(autoplay) {

      var on_player_ready = _.bind(function() {
        this.player_ready = true;
        this.listen_for_events();
        if (this.video_id) {
          this.load(this.video_id, this.cover_img_url, autoplay || this.autoplay);
        }
      }, this);

      var on_player_state_change = _.bind(function(state) {
        switch (state.data) {
          case 0: // ended
            this.trigger(`state:ended`);
            this.stop_progress_tracking();
            break;
          case 1: // playing
            this.trigger(`state:playing`);
            this.start_progress_tracking();
            break;
          case 2: // paused
            this.trigger(`state:paused`);
            this.stop_progress_tracking();
            break;
          case 3: // buffering
            this.trigger(`state:buffering`);
            break;
        }
      }, this);

      this.api = new YT.Player(this.yt_id, {
        width: `100%`,
        height: `100%`,
        playerVars: {
          showinfo: 0,
          rel: 0,
          autohide: 1,
          modestbranding: 1,
          controls: 2,
        },
        events: {
          'onReady': on_player_ready,
          'onStateChange': on_player_state_change,
        },
      });
    },

    check_api() {
      try {
        this.api.getPlayerState();
        return true;
      } catch (err) {
        return false;
      }
    },

    check_player(autoplay) {
      if (!this.check_api()) {
        this.load_api(autoplay);
        return false;
      }
      return this.player_ready;
    },

    start_progress_tracking() {
      this.time_tracking_id = window.setInterval(_.bind(function() {
        try {
          var progress = this.api.getCurrentTime() / this.api.getDuration();
          this.trigger(`progress`, progress);
        } catch (err) {
          // this happens when the youtube video has somehow
          // been hidden from the page.  Like if it is in a
          // modal and the modal is closed while playing
          this.stop_progress_tracking();
        }
      }, this), 1000);
    },

    stop_progress_tracking() {
      if (this.time_tracking_id) {
        window.clearInterval(this.time_tracking_id);
        this.time_tracking_id = null;
      }
    },

    load(video_id, cover_img_url, autoplay) {
      this.video_id = video_id;
      this.cover_img_url = cover_img_url || undefined;
      this.autoplay = autoplay;

      if (this.cover_img_url) {
        this.cover.show();
        this.cover_img.attr(`src`, this.cover_img_url);
      } else { this.cover.hide(); }

      // resize modal window
      if (this.mw) { this.mw.resize(); }

      if (!this.check_player()) { return; }

      this.api.cueVideoById(this.video_id);
      this.api.setPlaybackQuality(`hd720`);
      if (this.autoplay) { this.play(); }
    },

    play() {
      if (!this.check_player(true)) { return; }
      this.cover.hide();

      // resize player to 16 x 9
      window.setTimeout(_.bind(function() {
        var width = this.$el.width();
        this.$el.height(width * 9 / 16);
      }, this), 200);

      if (this.video_id) { this.api.loadVideoById(this.video_id, 0, `hd720`); }
      else { this.api.playVideo(); }
    },

    restart() {
      if (!this.check_player(true)) { return; }

      this.api.seekTo(0);
      this.play();
    },
  });

  return {
    YouTubeView,
  };
});

}.call(window));